<template>
  <div>
    <div v-show="loading" class="row">
      <Loader style="width: 100%;" />
    </div>
    <div v-show="!loading" id="cronofy-availability-viewer"></div>
  </div>
</template>

<script>
import CounselorClient from '@/api/CounselorClient';
import Loader from '@/components/Loader.vue';
import moment from 'moment';

export default {
    name: 'CronofyAvailabilityViewer',
    components: {
      Loader
    },
    props: {
        selectedSlot: {
          type: Object,
          required: true
        },
    },
    data() {
        return {
          counselorClient: new CounselorClient(this.$http),
          loading: true,
          events: []
        }
    },
    async mounted() {
        try {
          const response = await this.counselorClient.getAvailabilityToken(this.$store.getters.currentUser.counselor_profile.id);
          this.initializeAvailability(response);

          this.loading = false;
        } catch (e) {
          console.error(e);
        }
      },
    methods: {
      initializeAvailability(response) {
          window.CronofyElements.AvailabilityViewer({
            tzid: this.$now.timezone().name,
            element_token: response.token.token,
            target_id: 'cronofy-availability-viewer',
            config: {
              start_time: '08:00',
              end_time: '20:00',
              interval: 30,
              mode: 'no_confirm',
              slot_selection: 'unrestricted',
              allow_expansion: true
            },
            availability_query: {
              response_format: 'overlapping_slots',
              start_interval: { minutes: 30 },
              required_duration: { minutes: 50 },
              participants: [
                {
                  required: 'all',
                  members: response.token.subjects.map(subject => ({
                    sub: subject,
                    managed_availability: true
                  }))
                }
              ],
              query_periods: [
                {
                  start: moment().toISOString(),
                  end: moment().add(90, 'days').toISOString()
                }
              ]
            },
            styles: {
              prefix: 'scheduler',
              colors: {
                available: '#15b3d6',
                unavailable: '#fff'
              }
            },
            callback: notification => {
                if (!notification || !notification.notification) { return }

                const { type } = notification.notification

                if (type === 'error') { console.error(notification.notification) } else if (type === 'warn') { console.warn(notification.notification) }

                if (type === 'displayed_dates_changed') {
                  this.getCalendarEvents(notification.notification.firstDay, moment(notification.notification.lastDay).endOf('day').toISOString());
                }

                if (type === 'slot_selected') {
                  const { slot } = notification.notification;
                  this.onSessionSlotSelected(slot);
                }
              }
          });
      },
      onSessionSlotSelected(slot) {
          let data = {}
          if (moment(slot.start) > moment()) {
            data = {
              start: slot.start,
              end: slot.end,
              events: this.findMatchingSlots(slot.start, slot.end)
            }
          }
          this.$emit('set-selected-slot', data);
        },
        findMatchingSlots(start, end) {
          const matchingEvents = this.events.filter(event => event.start < end && event.end > start);
          return matchingEvents.length > 0 ? matchingEvents : [];
        },
        async getCalendarEvents(start, end) {
          try {
            const response = await this.counselorClient.getCalendarEvents(this.$store.getters.currentUser.counselor_profile.id, start, end);
            this.events = response.events.map(x => {
              const [calendarName, profileName] = x.summary.split(',');
              return {
                ...x,
                calendarName,
                profileName
            };
          })
          } catch (ex) {
              console.error(ex.message);
          }
        },
      }
}
</script>

<style lang="scss">

.scheduler {
      .scheduler__navigation {
        position: absolute;
        top: 0;
        right: 0;
      }

      .scheduler__month-labels {
        padding-top: 20px;
      }

      .scheduler__example.scheduler__example--unavailable {
        background-color: #fff;
      }

      .scheduler__time-text {
        color: #fff;
      }

      .scheduler__month-labels {
        padding-top: 0px;

        .scheduler__month-label {
          font-size: 30px;
        }
      }

      .scheduler__time-expander-button {
        svg {
          fill: #fff;
        }
      }
      .scheduler__time-expander-button:hover {
        svg {
          fill: $green;
      }
    }
}

</style>
